import { ref } from "vue";

const webViewDebugModeOn = ref(false);

const initWebviewDebugMode = (): void => {
    try {
        if (environment.env == "Production") {
            return;
        }

        // Create debug button
        const debugBtn = document.createElement("button");
        debugBtn.className = "webview-debug";
        debugBtn.onclick = () => {
            webViewDebugModeOn.value = !webViewDebugModeOn.value;
            $(".webview-debug__mode").toggleClass("webview-debug__mode--active");
        };

        debugBtn.insertAdjacentHTML(
            "beforeend",
            '<span>WebView Debug</span> <span class="webview-debug__mode">Active</span>'
        );
        document.querySelector("main").appendChild(debugBtn);
    } catch (e) {
        console.error(`WebView Debug Mode Initialiazation Failed: ${e}`);
    }
};

const showEventAlert = (interfaceName: string, methodName: string, argument: string): void => {
    try {
        if (!webViewDebugModeOn.value) return;

        const eventMessage =
            argument !== null && argument !== undefined
                ? `Interface ${interfaceName}; method ${methodName}('${argument}')`
                : `Interface ${interfaceName}; method ${methodName}()`;
        confirm(eventMessage);
    } catch (e) {
        console.error(`Show Alert For WebView Debug Mode Failed: ${e}`);
    }
};

export default function useWebviewDebugMode() {
    return {
        showEventAlert,
        initWebviewDebugMode,
    };
}
